var React = require('react');

function ArrowDown (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M17.1465 20.0303L9.26248 27.9143L1.37848 20.0303","strokeWidth":"1.5","key":0}),React.createElement("path",{"d":"M9.2627 27.914L9.2627 0.5","strokeWidth":"1.5","key":1})]);
}

ArrowDown.defaultProps = {"width":"18","height":"29","viewBox":"0 0 18 29","fill":"none"};

module.exports = ArrowDown;

ArrowDown.default = ArrowDown;
